<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-26 09:58:36
 * @FilePath: 
 * @Description: 注册微会员验证手机号
-->
<template>
  <div class="full_page register_page">
    <div class="store_logo_con">
      <img :src="logoImgUrl" alt="" />
    </div>
    <div class="register_form_con" v-if="mRegisterMemberByMiniApp === false">
      <van-form @submit="onSubmit">
        <van-field v-model="formData.MobilePhone" type="tel" name="MobilePhone" maxlength="11" label="手机号"
          placeholder="请输入手机号" :error="false" :rules="[{ required: true, message: '请输入手机号' }]">
          <template #button>
            <g-send-code :disabled.sync="codeDiabled" :phone="formData.MobilePhone" :click="handleGetCode"
              color="var(--tc)" ref="sendRef"></g-send-code>
            <!-- <van-button size="small" type="primary" @click="handleGetCode">获取验证码</van-button> -->
          </template>
        </van-field>
        <van-field v-model="formData.SmsCode" type="number" maxlength="6" name="SmsCode" label="验证码"
          placeholder="请输入验证码" :error="false" :rules="[{ required: true, message: '请输入验证码' }]" />
        <div style="margin: 16px">
          <van-button block color="var(--tc)" native-type="submit" :loading="isSubmiting"
            loading-text="提交中...">提交</van-button>
        </div>
      </van-form>
    </div>

    <div class="register_form_con" v-else>
  <van-form>
    <div style="margin: 16px; position: relative; ">
      <!-- 普通按钮，用于视觉展示 -->
      <van-button 
        block 
        color="var(--tc)" 
        native-type="button"
        :loading="isSubmiting"
        loading-text="注册..."
      >注册</van-button>
      <!-- 微信跳转层：透明覆盖在按钮上 -->
      <wx-open-launch-weapp 
        id="launch-btn" 
        username="gh_c2e34a2cd75b" 
        path="customPage/homePage/homePage"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0;background-color: transparent;"
      >
        <template>
          <div style="width: 100%; height: 100%;"></div>
        </template>
      </wx-open-launch-weapp>
    </div>
  </van-form>
</div>
  </div>
</template>

<script>
import { validMiniMember } from "@/api/member";
import { handleLocalStorage } from "@/utils";
import wxConfig from "@/utils/wxConfig";
export default {
  name: "ValidMember",
  props: {},
  data() {
    return {
      mRegisterMemberByMiniApp: true, //是否跳转小程序  未实现
      logoImgUrl: "",
      codeDiabled: false,
      formData: {
        MobilePhone: "",
        SmsCode: "",
      },
      isSubmiting: false,
      returnurl: ''
    };
  },
  components: {},
  onload(option) {
  },

  watch: {
    "formData.MobilePhone"(val) {
      if (val.length === 11) {
        this.codeDiabled = false;
      } else {
        this.codeDiabled = true;
      }
    },
  },
  created() {
    // 3. 如果是跳转小程序模式，初始化微信SDK
    if (this.mRegisterMemberByMiniApp === true) {
        wxConfig.getWxParameter(this)
        this.initWechatSDK();
    }
  },
  mounted() {
    const vpnInfo = this.$store.state.vpnInfo;
    console.log("vpnInfo==== "+JSON.stringify(vpnInfo))
    console.log(this.$store);
    const imgArr = vpnInfo.Claims;
    if (imgArr instanceof Array && imgArr.length > 0) {
      const imgItem = imgArr.find((subItem) => subItem.TypeId === 2);
      if (imgItem) {
        this.logoImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
      }
    }
    let tempReturnurl = handleLocalStorage.get('returnurl')
    if (tempReturnurl && tempReturnurl != undefined && (tempReturnurl + '').length > 10) {
      this.returnurl = tempReturnurl.replace('/MinMember/ValidMember?returnurl=', '')
      this.returnurl = decodeURIComponent(this.returnurl)
      const hashIndex = this.returnurl.indexOf('#')
      const result = this.returnurl.substring(hashIndex + 1)
      this.returnurl = result
    }
  },
  methods: {
    /**
     * 初始化微信 JSSDK（用于开放标签）
     */
    initWechatSDK() {
      // 调用后端接口获取微信配置参数
      // 注意：这里的接口地址需要根据你的实际后端接口调整
      let mUrl = encodeURIComponent(window.location.href.split("#")[0]);
      console.log('mUrl===='+mUrl)
      let sendParams = { url: mUrl };
      $http('wechath5/zh-cn/v1/wrapper/jssdk', sendParams).then(res => {
        console.log("initWechatSDK==== "+JSON.stringify(res))
        if (res.data) {
          const config = res.data;
          wx.config({
            debug: false, // 开发时可设为 true 查看详细日志
            appId: config.appId,
            timestamp: config.timestamp,
            nonceStr: config.nonceStr,
            signature: config.signature,
            jsApiList: ['chooseImage'], // 必填，随意一个接口即可
            openTagList: ['wx-open-launch-weapp'] // 必须包含开放标签
          });
          
          wx.ready(() => {
            console.log('微信 JSSDK 初始化成功');
          });
          
          wx.error((err) => {
            console.log('微信 JSSDK 初始化失败:', err);
          });
        }
      }).catch(err => {
        console.log('获取微信配置失败:', err);
      });
    },

    handleGetCode() {
      $http(
        "wechath5/zh-cn/v1/member/sendsmscode?phone=" +
        this.formData.MobilePhone
      ).then((res) => {
        this.$toast("发送验证码成功");
        this.$refs.sendRef.activeCode();
      });
    },
    onSubmit(values) {

      console.log("submit", values);
      this.isSubmiting = true;
      validMiniMember(values)
        .then((res) => {
          this.isSubmiting = false;
          this.$router.push({
            name: "RegisteredMember",
            query: { phone: this.formData.MobilePhone, returnurl: this.returnurl },
          });
        })
        .catch(() => {
          this.isSubmiting = false;
           this.$router.push({
            name: "RegisteredMember",
            query: { phone: this.formData.MobilePhone, returnurl: this.returnurl },
          });
        });
    }, 
  },
};
</script>
<style scoped lang="scss">
.register_page {
  background: linear-gradient(180deg, #f4f3f0 0%, #fff 100%);
  padding-top: 1px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .store_logo_con {
    margin: 290px 135px 0;

    img {
      width: 100%;
    }
  }

  .register_form_con {
    padding: 0 30px 300px;
  }
}
</style>
